import AsyncStorage from '@react-native-async-storage/async-storage';

// Storage keys
const NOTIFICATION_PREF_KEY = '@notification_preference';
const FIRST_LAUNCH_KEY = '@has_seen_notification_prompt';

// Notification preference types
export type NotificationMode = 'all' | 'important';

/**
 * Get the current notification preference
 * Defaults to 'important' if not set
 */
export const getNotificationPreference = async (): Promise<NotificationMode> => {
  try {
    const value = await AsyncStorage.getItem(NOTIFICATION_PREF_KEY);
    if (value === 'all' || value === 'important') {
      return value;
    }
    return 'all'; // Default
  } catch (error) {
    console.log('Error getting notification preference:', error);
    return 'all';
  }
};

/**
 * Set the notification preference
 */
export const setNotificationPreference = async (mode: NotificationMode): Promise<void> => {
  try {
    await AsyncStorage.setItem(NOTIFICATION_PREF_KEY, mode);
    console.log('Notification preference saved:', mode);
  } catch (error) {
    console.log('Error saving notification preference:', error);
  }
};

/**
 * Check if user has seen the notification prompt
 */
export const hasSeenNotificationPrompt = async (): Promise<boolean> => {
  try {
    const value = await AsyncStorage.getItem(FIRST_LAUNCH_KEY);
    return value === 'true';
  } catch (error) {
    console.log('Error checking notification prompt status:', error);
    return false;
  }
};

/**
 * Mark the notification prompt as seen
 */
export const markNotificationPromptSeen = async (): Promise<void> => {
  try {
    await AsyncStorage.setItem(FIRST_LAUNCH_KEY, 'true');
    console.log('Notification prompt marked as seen');
  } catch (error) {
    console.log('Error marking notification prompt as seen:', error);
  }
};
